import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderService } from './services/loader.service';
import { TimeoutIdleService } from './core/services/timeout-idle.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Analytiko';
  constructor(
    public router: Router,
    private _snackBar: MatSnackBar,
    public loaderService: LoaderService,
    private readonly idleService: TimeoutIdleService
  ) {
    this.idleService.startWatching();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
}
